import React from 'react';
import { TypeLiquidation, TargetCoinLiquidation } from '../coinLiquidation/types';

interface LiquidationSettingsProps {
  typeLiquidation: TypeLiquidation;
  targetCoin: TargetCoinLiquidation;
  globalLiquidationPercentage: number;
  nativeLockUsd: number;
  onTargetCoinChange: (coin: TargetCoinLiquidation) => void;
  onGlobalLiquidationPercentageChange: (percentage: number) => void;
  onNativeLockUsdChange: (usd: number) => void;
}

export const LiquidationSettings: React.FC<LiquidationSettingsProps> = ({
  typeLiquidation,
  targetCoin,
  globalLiquidationPercentage,
  nativeLockUsd,
  onTargetCoinChange,
  onGlobalLiquidationPercentageChange,
  onNativeLockUsdChange,
}) => {
  return (
    <div className="bg-gray-800 rounded-lg p-4 sm:p-5 md:p-6">
      <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Liquidation Settings</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6">
        {/* Target Coin */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Target Coin
          </label>
          <select
            value={targetCoin}
            onChange={(e) => onTargetCoinChange(e.target.value as TargetCoinLiquidation)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2.5 sm:py-2 text-white text-base min-h-[48px] sm:min-h-[44px]"
          >
            <option value={TargetCoinLiquidation.USDC}>USDC</option>
            <option value={TargetCoinLiquidation.USDT}>USDT</option>
            <option value={TargetCoinLiquidation.NATIVE}>Native Token</option>
          </select>
        </div>

        {/* Native Token Lock (USD) */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Native Token Lock (USD)
          </label>
          <input
            type="number"
            min={0}
            step={0.01}
            value={nativeLockUsd}
            onChange={(e) => onNativeLockUsdChange(Number(e.target.value) || 0)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2.5 sm:py-2 text-white text-base min-h-[48px] sm:min-h-[44px]"
          />
          <p className="text-xs text-gray-400 mt-1">
            This amount will be kept in native tokens per chain for gas and future buyback.
          </p>
        </div>
      </div>

      {/* Global Liquidation Percentage */}
      {typeLiquidation === TypeLiquidation.GLOBAL && (
        <div className="mt-4 sm:mt-5 md:mt-6">
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Liquidation Percentage: {globalLiquidationPercentage}%
          </label>
          <input
            type="range"
            min="1"
            max="100"
            value={globalLiquidationPercentage}
            onChange={(e) => onGlobalLiquidationPercentageChange(Number(e.target.value))}
            className="w-full h-3 sm:h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer"
            style={{ minHeight: '44px', touchAction: 'none' }}
          />
        </div>
      )}
    </div>
  );
};

